import React from 'react';
import { ALERT_VARIANT } from './enums';
import { PrimaryWarningAlert, SecondaryWarningAlert, PrimaryErrorAlert, SecondaryErrorAlert, PrimarySuccessAlert, SecondarySuccessAlert, PrimaryInfoAlert, SecondaryInfoAlert, } from './components';
import { Icon } from '../styled-icon';
import { faKeynote } from '@fortawesome/pro-light-svg-icons';
const ALERT_MAP = {
    [ALERT_VARIANT.WARNING]: {
        defaultIcon: faKeynote,
        comp: PrimaryWarningAlert,
    },
    [ALERT_VARIANT.WARNING_BOLD]: {
        defaultIcon: faKeynote,
        comp: SecondaryWarningAlert,
    },
    [ALERT_VARIANT.ERROR]: {
        defaultIcon: faKeynote,
        comp: PrimaryErrorAlert,
    },
    [ALERT_VARIANT.ERROR_BOLD]: {
        defaultIcon: faKeynote,
        comp: SecondaryErrorAlert,
    },
    [ALERT_VARIANT.INFO]: {
        defaultIcon: faKeynote,
        comp: PrimaryInfoAlert,
    },
    [ALERT_VARIANT.INFO_BOLD]: {
        defaultIcon: faKeynote,
        comp: SecondaryInfoAlert,
    },
    [ALERT_VARIANT.SUCCESS]: {
        defaultIcon: faKeynote,
        comp: PrimarySuccessAlert,
    },
    [ALERT_VARIANT.SUCCESS_BOLD]: {
        defaultIcon: faKeynote,
        comp: SecondarySuccessAlert,
    },
};
export const Alert = (props) => {
    const { variant = ALERT_VARIANT.WARNING, children, icon, useDefaultIcon = true } = props;
    const Comp = ALERT_MAP[variant].comp;
    return (React.createElement(Comp, null,
        useDefaultIcon && (React.createElement(Icon, { iconSize: 20, icon: (icon || ALERT_MAP[variant].defaultIcon) })),
        React.createElement("div", null, children)));
};
//# sourceMappingURL=Alerts.js.map